module.exports = __webpack_public_path__ + "static/media/test.731f3b64.svg";